import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { SalaryRule } from './SalaryRule';

export class BasicSalary extends SalaryRule {
    _originalTypeClassName = "zERP.BO.BasicSalary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BasicSalary.translate = translateService;
}
super();
this.IsPercentage = false;
this.PercentageHourlySalary = null;
this.PercentageDailySalary = null;
this.IsTheBasic = false;
this.KaeCode = null;
this.EapCode = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
IsPercentage:any;
PercentageHourlySalary:any;
PercentageDailySalary:any;
IsTheBasic:any;
KaeCode:any;
EapCode:any;

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}